/**
 * @flow
 * @relayHash 5e3d050eca9a6a6fa1e571cc3c55aba9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type GpxMediaList_gpxFileMedia$ref = any;
export type EventGpsSearchPageRefetchQueryVariables = {|
  eventId: string,
  gpxFileId?: ?string,
  count: number,
  cursor?: ?string,
  isRecheckPage: boolean,
  stravaToken?: ?string,
  stravaActivityId?: ?number,
  stravaActivityStartDate?: ?any,
  hasStravaToken: boolean,
|};
export type EventGpsSearchPageRefetchQueryResponse = {|
  +viewer: ?{|
    +event: ?{|
      +media?: ?{|
        +$fragmentRefs: GpxMediaList_gpxFileMedia$ref
      |}
    |}
  |}
|};
export type EventGpsSearchPageRefetchQuery = {|
  variables: EventGpsSearchPageRefetchQueryVariables,
  response: EventGpsSearchPageRefetchQueryResponse,
|};
*/


/*
query EventGpsSearchPageRefetchQuery(
  $eventId: ID!
  $gpxFileId: ID
  $count: Int!
  $cursor: String
  $isRecheckPage: Boolean!
  $stravaToken: String
  $stravaActivityId: Int
  $stravaActivityStartDate: NaiveDatetime
  $hasStravaToken: Boolean!
) {
  viewer {
    event(id: $eventId) {
      media: searchMediaByGpx(gpxFileId: $gpxFileId) @skip(if: $hasStravaToken) {
        ...GpxMediaList_gpxFileMedia
      }
      media: mediaByStravaActivity(stravaAccessToken: $stravaToken, stravaActivityId: $stravaActivityId, stravaActivityStartDate: $stravaActivityStartDate) @include(if: $hasStravaToken) {
        ...GpxMediaList_gpxFileMedia
      }
      id
    }
    id
  }
}

fragment GpxMediaList_gpxFileMedia on ExtendedMediaConnection {
  mediaList(first: $count, after: $cursor) {
    edges {
      node {
        id
        __typename
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    ...MediaList_media
  }
}

fragment MediaListItem_item on Media {
  id
  sgId
  name
  shotDate
  recheckStatus
  variants {
    name
    url
    id
  }
}

fragment MediaList_media on MediaConnection {
  edges {
    node {
      id
      sgId
      shotDate
      variants {
        name
        url
        id
      }
      recheckStatus
      recheckRequestedAt @include(if: $isRecheckPage)
      ...MediaListItem_item
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "eventId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "gpxFileId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isRecheckPage",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "stravaToken",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "stravaActivityId",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "stravaActivityStartDate",
    "type": "NaiveDatetime",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasStravaToken",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "eventId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "gpxFileId",
    "variableName": "gpxFileId"
  }
],
v3 = [
  {
    "kind": "FragmentSpread",
    "name": "GpxMediaList_gpxFileMedia",
    "args": null
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "stravaAccessToken",
    "variableName": "stravaToken"
  },
  {
    "kind": "Variable",
    "name": "stravaActivityId",
    "variableName": "stravaActivityId"
  },
  {
    "kind": "Variable",
    "name": "stravaActivityStartDate",
    "variableName": "stravaActivityStartDate"
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v8 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "mediaList",
    "storageKey": null,
    "args": (v6/*: any*/),
    "concreteType": "MediaConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "MediaEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Media",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "sgId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "shotDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "variants",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recheckStatus",
                "args": null,
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isRecheckPage",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "recheckRequestedAt",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasNextPage",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "endCursor",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  {
    "kind": "LinkedHandle",
    "alias": null,
    "name": "mediaList",
    "args": (v6/*: any*/),
    "handle": "connection",
    "key": "GpxMediaList_mediaList",
    "filters": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "EventGpsSearchPageRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Event",
            "plural": false,
            "selections": [
              {
                "kind": "Condition",
                "passingValue": false,
                "condition": "hasStravaToken",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "media",
                    "name": "searchMediaByGpx",
                    "storageKey": null,
                    "args": (v2/*: any*/),
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasStravaToken",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "media",
                    "name": "mediaByStravaActivity",
                    "storageKey": null,
                    "args": (v4/*: any*/),
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": (v3/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EventGpsSearchPageRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "event",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "Event",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "Condition",
                "passingValue": false,
                "condition": "hasStravaToken",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "media",
                    "name": "searchMediaByGpx",
                    "storageKey": null,
                    "args": (v2/*: any*/),
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  }
                ]
              },
              {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasStravaToken",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": "media",
                    "name": "mediaByStravaActivity",
                    "storageKey": null,
                    "args": (v4/*: any*/),
                    "concreteType": "ExtendedMediaConnection",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  }
                ]
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "EventGpsSearchPageRefetchQuery",
    "id": null,
    "text": "query EventGpsSearchPageRefetchQuery(\n  $eventId: ID!\n  $gpxFileId: ID\n  $count: Int!\n  $cursor: String\n  $isRecheckPage: Boolean!\n  $stravaToken: String\n  $stravaActivityId: Int\n  $stravaActivityStartDate: NaiveDatetime\n  $hasStravaToken: Boolean!\n) {\n  viewer {\n    event(id: $eventId) {\n      media: searchMediaByGpx(gpxFileId: $gpxFileId) @skip(if: $hasStravaToken) {\n        ...GpxMediaList_gpxFileMedia\n      }\n      media: mediaByStravaActivity(stravaAccessToken: $stravaToken, stravaActivityId: $stravaActivityId, stravaActivityStartDate: $stravaActivityStartDate) @include(if: $hasStravaToken) {\n        ...GpxMediaList_gpxFileMedia\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment GpxMediaList_gpxFileMedia on ExtendedMediaConnection {\n  mediaList(first: $count, after: $cursor) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    ...MediaList_media\n  }\n}\n\nfragment MediaListItem_item on Media {\n  id\n  sgId\n  name\n  shotDate\n  recheckStatus\n  variants {\n    name\n    url\n    id\n  }\n}\n\nfragment MediaList_media on MediaConnection {\n  edges {\n    node {\n      id\n      sgId\n      shotDate\n      variants {\n        name\n        url\n        id\n      }\n      recheckStatus\n      recheckRequestedAt @include(if: $isRecheckPage)\n      ...MediaListItem_item\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'eab367781f26944908f70e54b4819cc4';

module.exports = node;
